module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', {
    staticClass: "pa-2 d-flex align-center rounded",
    staticStyle: {
      "min-height": "64px"
    },
    attrs: {
      "outlined": ""
    }
  }, [_c('v-text-field', {
    staticClass: "rounded-pill flex-grow-1 mr-4",
    attrs: {
      "label": "Search",
      "hide-details": "",
      "dense": "",
      "clearable": "",
      "solo": "",
      "flat": "",
      "prepend-inner-icon": "mdi-magnify"
    },
    on: {
      "input": _vm.emitSearch
    },
    model: {
      value: (_vm.searchText),
      callback: function($$v) {
        _vm.searchText = $$v
      },
      expression: "searchText"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "d-flex align-center",
    staticStyle: {
      "gap": "8px"
    }
  }, [_c('v-select', {
    staticStyle: {
      "min-width": "140px"
    },
    attrs: {
      "items": _vm.columns,
      "label": "Column",
      "item-text": "text",
      "item-value": "value",
      "dense": "",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": _vm.emitSearch
    },
    model: {
      value: (_vm.selectedColumn),
      callback: function($$v) {
        _vm.selectedColumn = $$v
      },
      expression: "selectedColumn"
    }
  }), _vm._v(" "), _c('v-select', {
    staticStyle: {
      "min-width": "140px"
    },
    attrs: {
      "items": _vm.searchModes,
      "placeholder": "Search Mode",
      "dense": "",
      "hide-details": "",
      "clearable": ""
    },
    on: {
      "change": _vm.emitSearch
    },
    model: {
      value: (_vm.searchMode),
      callback: function($$v) {
        _vm.searchMode = $$v
      },
      expression: "searchMode"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-071f80b6"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/appComponents/permissions/inputs/TableFilter.vue
// module id = 1799
// module chunks = 0